module.exports = __webpack_public_path__ + "static/SeeVita-08-f1c269fd330f5c9cfe4613c3d3fc9279.png";